<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input label="From Date" density="compact" prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month" single-line variant="outlined"
                        bg-color="grey-lighten-4" v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value" autocomplete="off" clearable></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input label="To Date" density="compact" single-line prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month" variant="outlined" bg-color="grey-lighten-4"
                        v-model="to_date.value.value" :error-messages="to_date.errorMessage.value" autocomplete="off"
                        clearable></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Supplier
                List</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">

                  <v-col md="4" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" single-line
                      hide-details density="compact" variant="outlined" bg-color="grey-lighten-4" class="pl-2"
                      clearable></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                          @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                          @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                          @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn v-if="$insertAccess($route.fullPath)" @click="goTo('/inventory/add-supplier')"
                        color="primary" variant="tonal" prepend-icon="mdi mdi-plus" rounded="xl">
                        Add Supplier
                      </v-btn>
                    </div>
                  </v-col>

                </v-row>
                <v-data-table :headers="headers" :items="getSchema" :loading="loading"
                  v-model:items-per-page="itemsPerPage" :search="search" :hover="true" density="compact">

                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.type="{ item }">
                    {{ item.type.name }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip 
                    v-if="item.status == 1" 
                    color="success" 
                    size="small" 
                    class="text-capitalize">
                      Active
                    </v-chip>

                    <v-chip 
                    v-else 
                    color="red" 
                    size="small" 
                    class="text-capitalize">
                      Inactive
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon class="me-2 edit-button" color="primary" @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)">
                      mdi mdi-pencil-outline
                    </v-icon>
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { ref } from "vue";
import { useField, useForm } from "vee-validate";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
export default {
  components: {

  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: false },
      { title: "Name", key: "supplier_name", align: "left", sortable: false },
      { title: "Email", key: "supplier_email", align: "left", sortable: false },
      { title: "Mobile", key: "supplier_mobile", align: "left", sortable: false },
      { title: "Country", key: "supplier_country.name", align: "left", sortable: false },
      { title: "Suplier Country", key: "supplier_country.name", align: "left", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false }
    ],
  }),
  watch: {
  },
  created() {
  },
  computed: {
    getSchema() {
      return this.$store.getters.getSupplierList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
       values.from_date = formattedDate(from_date.value.value);
       values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSupplierList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      from_date,
      to_date,
      errorMessages,
      submit,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => { });
    },
    editItem(item) {
      this.$store.commit('setEditingSupplier', item);
      this.$router.push({ name: 'add-supplier' });
      // this.data = { ...item };
      // this.dialog = true;
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = ['#SL', 'Code', 'Name', 'Email', 'Mobile', 'Comp_Country', 'Supl_Country', 'Status'];
      const rows = this.getSchema.map(item => [serialNumber++, item.code, item.name, item.email, item.mobile, item.company_country?.name, item.supplier_country?.name, item.status == 1 ? 'Active' : 'Inactive']);
      this.$exportTableToPDF(columns, rows, 'Supplier List', 'supplier_list_' + this.$fileDate())
    },
    exportToExcel() {
      var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'Comp_Country', 'Supl_Country', 'Status']];
      var serialNumber = 1;
      this.getSchema.forEach(item => {
        data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.company_country?.name, item.supplier_country?.name, item.status == 1 ? 'Active' : 'Inactive']);
      });
      this.$exportTableToExcel(data, 'supplier_list_' + this.$fileDate());
    },
    exportToCSV() {
      var data = [['#SL', 'Code', 'Name', 'Email', 'Mobile', 'Comp_Country', 'Supl_Country', 'Status']];
      var serialNumber = 1;
      this.getSchema.forEach(item => {
        data.push([serialNumber++, item.code, item.name, item.email, item.mobile, item.company_country?.name, item.supplier_country?.name, item.status == 1 ? 'Active' : 'Inactive']);
      });

      this.$exportTableToCSV(data, 'supplier_list_' + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
}
</script>